import { Injectable } from '@angular/core';

@Injectable()

export class CurrencyFormatterProvider {

    public PREFIX = ''
    public DECIMAL_SEPARATOR = ".";
    public THOUSANDS_SEPARATOR = ",";
    public SUFFIX = ' $'
    public PADDING = "000000";

    constructor(

    ) {

    }

    transform(value: string, fractionSize: number = 2): Promise<any> {
        value = value.toString().replace(/,/g, '').replace(/^0+/, '');
        if (this.isNumeric(value)) {
            let [integer, fraction = ""] = (value || "").toString().split(".");
            fraction = fractionSize > 0 ? this.DECIMAL_SEPARATOR + (fraction + this.PADDING).substring(0, fractionSize) : "";
            integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
            return Promise.resolve(this.PREFIX + integer + fraction);
        } else {
            return Promise.resolve(0);
        }
    }

    transform2(value: string, fractionSize: number = 2): string {
        value = value.toString().replace(/,/g, '').replace(/^0+/, '');
        if (this.isNumeric(value)) {
            let [integer, fraction = ""] = (value || "").toString().split(".");
            fraction = fractionSize > 0 ? this.DECIMAL_SEPARATOR + (fraction + this.PADDING).substring(0, fractionSize) : "";
            integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
            return this.PREFIX + integer + fraction;
        } else {
            return '0';
        }
    }

    parse(value: string, fractionSize: number = 2): Promise<any> {
        value = value.toString();
        let [integer, fraction = ""] = (value || "").replace(this.PREFIX, "").split(this.DECIMAL_SEPARATOR);
        integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, "g"), "");
        fraction = parseInt(fraction, 10) > 0 && fractionSize > 0 ? this.DECIMAL_SEPARATOR + (fraction + this.PADDING).substring(0, fractionSize) : "";
        return Promise.resolve(integer + fraction);
    }

    isNumeric(value: any): boolean {
        return !isNaN(value - parseFloat(value));
    }

    rupiahToDecimal(rupiah: any) {
        if (typeof(rupiah) == 'number') {
            return rupiah
        } else {
            if (rupiah.substring(0,3) == 'Rp.') {
                var rupiahTmp: string = rupiah.substr(3)
                return rupiahTmp.replace(/[.]/g, '')
            } else {
                return rupiah.replace(/[.]/g, '')
            }
            
        }

    }

}



// WEBPACK FOOTER //
// ./src/providers/currency-formatter/currency-formatter.ts